import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "page-content-inner" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-12-desktop" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "page-content-inner" }
const _hoisted_7 = { class: "button-wrap" }

import {useHead} from '@vueuse/head'
import {pageTitle} from '../../state/sidebarLayoutState'
import StockFuturesDashboard from "./streamalerts.vue";
//import Notifications from '../notifications/Notifications.vue'
import SidebarLayout from '../../layouts/SidebarLayout.vue'
import {computed} from "vue";
import {mapState} from "vuex";
import VButton from '../../components/base/button/VButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'StreamA',
  setup(__props) {

/**
 * This is a Vue Component that will be
 * automatically mapped to a entry on vue-router.
 *
 * You will be able to access this page at http://localhost:3000/sidebar-blank-page-6
 * Page uri will match related path to src/pages folder
 *
 * Read more about routing:
 * @see /vite.config.ts
 * @see /src/router.ts
 */

pageTitle.value = 'JB Drax Honoré'
useHead({
  title: 'JB Drax Honoré',
})
const user = computed(() => {
  return mapState(['user'])
});
const alertsObj: any = [];

return (_ctx: any,_cache: any) => {
  return (user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(SidebarLayout, { theme: "labels-hover" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(StockFuturesDashboard)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createVNode(SidebarLayout, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(VButton, {
                  color: "primary",
                  elevated: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('login')))
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Please login ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]))
}
}

})